import { Company } from '../../../types/company/company'
import { axios, Response } from '..'

const getCompany = (companyId: string): Response<Company> => {
  return axios.get(`/v1/companies/${companyId}`)
}

export default getCompany
